import { type UseControllerProps, type FieldValues, useController } from 'react-hook-form';

import {
  RadioWithIconSelection,
  type RadioWithIconSelectionProps,
} from '../../radio-with-icon-selection';

type FormRadioWithIconSelectionProps<TFieldValues extends FieldValues> =
  UseControllerProps<TFieldValues> & RadioWithIconSelectionProps;

function FormRadioWithIconSelection<TFieldValues extends FieldValues = FieldValues>(
  props: FormRadioWithIconSelectionProps<TFieldValues>,
) {
  const {
    field: { ref: fieldRef, ...field },
    fieldState: { error },
  } = useController({ ...props, name: props.name });

  return (
    <RadioWithIconSelection
      {...props}
      {...field}
      onChange={(event, value) => {
        props.onChange?.(event, value);
        field.onChange(value);
      }}
      error={!!error}
      helperText={error?.message ?? props.helperText ?? ''}
      ref={(ref: HTMLDivElement) => {
        fieldRef({
          focus: () => ref?.scrollIntoView({ block: 'center' }),
        });
      }}
    />
  );
}
FormRadioWithIconSelection.displayName = 'FormRadioWithIconSelection';

export type { FormRadioWithIconSelectionProps };
export default FormRadioWithIconSelection;
